<template>
  <div class="c-textarea">
		<validation-message
			:valid="valid"
			:invalid="invalid"
			:validationMessage="validationMessage"
		>
			<label class="c-textarea__label" :for="id">
				<textarea
          :id="id"
					class="c-textarea__field"
					:name="name" 
					:disabled="disabled" 	
					:required="required"
					:readonly="readonly"
					:placeholder="placeholder"
					v-model="value"
					@input="updateValue"
					@change="changeValue"
				/>
				<span class="c-textarea__label-text">
					{{label}}
					<span v-if="required" class="c-textarea__required"> *</span>
				</span>
		</label>

		</validation-message>
    <div v-if="tooltip" class="c-tooltip">
			<ToolTip :title="tooltipTitle" :isActive="isActiveTooltip" @toggleTooltip="(value) => $emit('toggleTooltip', value)">
        <span v-html="tooltipMessage"></span>
        <img v-if="tooltipImageUrl" width="84" height="117" :src="tooltipImageUrl"  alt="" />
      </ToolTip>
    </div>


	</div>
</template>

<script>
import ValidationMessage from '../../../../base/validation-message/ValidationMessage.vue';
import ToolTip from '../../_contact-us-rap/_vue/ToolTip.vue'
export default {
	components: { ValidationMessage, ToolTip },
	inheritAttrs: false,
	props: {
    id: {
      required: true,
      type: String,
    },
    label: {
      required: true,
      type: String,
    },
		placeholder: {
      required: false,
      type: String,
			default: "",
    },
    required: {
      required: false,
      type: Boolean,
    },
		disabled: {
      required: false,
      type: Boolean,
    },
		tooltip: {
      required: false,
      type: Boolean,
    },
    tooltipTitle: {
      required: false,
      type: String,
    },
		tooltipMessage:{
			required: false,
      type: String,
		},
    tooltipImageUrl: {
      required: false,
      default: '',
      type: String,
    },
    isActiveTooltip: {
      type: Boolean,
    },
    value: {
      type: [String, Number],
    },
		valid: {
      type: Boolean,
      default: null
    },
    invalid: {
      type: Boolean,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    validationMessage: {
      required: false,
      type: String,
    },
  },
	methods: {
    updateValue(event) {
			this.inputValue = event.target.value;
			this.$emit('input', this.inputValue); 
		},
		changeValue(event){
			this.inputValue = event.target.value;
			this.$emit('change', this.inputValue); 
		}
  },
}
</script>


// WEBPACK FOOTER //
// src/components/components/reportAProblem/forms/textarea/TextareaField.vue